import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'

const DEFAULT_IMG = toAbsoluteUrl('media/crm/backgrounds/crm.jpg')

type Props = {
    title: string
    subtitle?: string
    image?: string
    topImage?: string
}

const DashboardPreview: FC<Props> = ({title, subtitle, image, topImage}) => {
    return (
        <div className='moduleWidgets_DashboardPreview card card-flush mb-6'>
            <div className='card-body d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-4'>
                <div className='moduleWidgets_DashboardPreviewTitle'>
                    {topImage && (
                        <img
                            className='moduleWidgets_DashboardPreviewTopImage'
                            src={topImage}
                            alt='logo'
                        />
                    )}
                    <h2 className='mb-2'>{title}</h2>
                    {subtitle ? (
                        <div className='text-gray-600 fs-6'>
                            {subtitle === 'null' ? '' : subtitle}
                        </div>
                    ) : (
                        ''
                    )}
                </div>
                {image ? (
                    <div className='moduleWidgets_DashboardPreviewImage'>
                        <img
                            src={image}
                            alt='dashboard'
                            onError={(e) => (e.currentTarget.src = DEFAULT_IMG)}
                        />
                    </div>
                ) : null}
            </div>
        </div>
    )
}

export default DashboardPreview
